import { render } from "./AirMeasurements.vue?vue&type=template&id=410c4b26&scoped=true"
const script = {}

import "./AirMeasurements.vue?vue&type=style&index=0&id=410c4b26&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-410c4b26"

export default script